import { OptionDropdown } from './ForecastModels';

export enum ENTITY_STATUS {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

// Campaign API response
export interface DMMProductLineCampaign {
  data_classification_id: number;
  product_code: string;
  campaign_seq_id: number | null;
  product_line_campaign_id: number | null;

  product_line_campaign_name: string;

  campaign_owner: string | null; // optional
  country_code: string;

  revenue_estimate: string | null; // optional
  business_category: string | null; // optional

  campaign_dimensions: CampaignDimension[]; // all are mandatory

  is_active: boolean;
  created_at: string;
  created_by: string;
  updated_at: string;
  updated_by: string;
}

export interface DMMProductLineCampaignFlattenMutation extends DMMProductLineCampaign {
  operation_type: string;
  export_s3_bucket: string;
  export_s3_key: string;
  export_s3_region: string;
}

export interface CampaignDimension {
  dimension_id: number;
  dimension_key: string;
  dimension_name: string;
  dimension_value: string;
}

// Used it to display it in Table (Flattened)
export interface DMMProductLineCampaignFlatten extends Omit<DMMProductLineCampaign, 'campaign_dimensions'> {
  campaign_status: ENTITY_STATUS;
  [key: string]: string | number | boolean | null;
}

// User for Campaign Form
export interface CampaignFormValues {
  data_classification_id: number;
  campaign_seq_id: number | null;
  product_line_campaign_id: number | null;

  product_line_campaign_name: string;
  product_code: string;
  campaign_owner: OptionDropdown | null;
  country_code: OptionDropdown;
  business_category: OptionDropdown | null;
  revenue_estimate: OptionDropdown | null;
  is_active: boolean;
  created_at: string;
  created_by: string;
  updated_at: string;
  updated_by: string;
  [key: string]: any; // For dynamic dimension fields
}

export interface CountryCompanyMapping {
  country_company_id: number;
  country_code: string;
  company_code: string;
}

/**
 * A row of xpt.map_dmm_account_channel_funnel — the GL account -> Channel + Funnel defaults
 * shared by every DMM product line. funnel is null for accounts with no Funnel default.
 */
export interface DmmAccountChannelFunnelMapping {
  account_code: string;
  channel_name: string;
  funnel: string | null;
}

export interface CampaignsMetadata {
  campaigns_metadata_key: string;
  campaigns_metadata_name: string;
  campaigns_metadata_value: string[];
}

export interface CampaignDimensionMetadata {
  dimension_id: number;
  dimension_key: string;
  dimension_name: string;
  dimension_values: DimensionValue[];
  data_classification_id: number;
  is_active: boolean;
  is_required: boolean;
  created_by: string;
  updated_by: string;
  created_at: string;
  updated_at: string;
}

export interface DimensionValue {
  value: string;
  value_desc: null;
  conditional_relationship: ConditionalRelationship[];
}

export interface ConditionalRelationship {
  dimension_id: null | null | number | number;
  dimension_key: null | null | string | string;
  valid_values: string[];
  invalid_values: string[];
}

export interface CampaignDimensionMetadataFormModel {
  key: string;
  name: string;
  dropdownValues: OptionDropdown[];
  isRequired: boolean;
}

export type DMMBusinessSegmentType =
  | 'Product Line'
  | 'Campaign Name'
  | 'Campaign Owner'
  | 'Country'
  | 'Revenue Estimate'
  | 'Business Category'
  | 'Spend Category'
  | 'Efficiency Management'
  | 'Channel Name'
  | 'Desired Business Impact';
